<div class="flex flex-col items-center group select-none">
  <!-- Club jersey -->
  <div
    class="relative flex items-center justify-center transition-all duration-200 group-hover:scale-105"
    [class]="containerSizeClasses()"
    [class.cursor-pointer]="isUser()"
    (click)="onJerseyClick()"
    [title]="isUser() ? (sponsor() ? 'Patrocinador oficial de camiseta: ' + sponsorName() : 'Contratar patrocinador de camiseta') : (sponsorName() || 'Camiseta oficial')"
  >
    <!-- Home or away kit -->
    <svg
      viewBox="0 0 160 145"
      class="w-full h-full drop-shadow-md"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <!-- Fabric shading for each kit -->
        <linearGradient [id]="'jerseyWhiteGrad-' + uniqueId" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" [attr.stop-color]="variant() === 'away' ? '#dbeafe' : '#ffffff'"/>
          <stop offset="65%" [attr.stop-color]="variant() === 'away' ? '#bfdbfe' : '#fcfcfd'"/>
          <stop offset="100%" [attr.stop-color]="variant() === 'away' ? '#93c5fd' : '#f1f5f9'"/>
        </linearGradient>

        <!-- Drop shadow for the club crest -->
        <filter [id]="'badgeShadow-' + uniqueId" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="1" stdDeviation="1" flood-opacity="0.25"/>
        </filter>
      </defs>

      <!-- Jersey silhouette -->
      <path
        d="M 62 18 L 28 30 L 6 60 L 20 74 L 38 56 L 34 130 Q 80 135 126 130 L 122 56 L 140 74 L 154 60 L 132 30 L 98 18 Q 80 26 62 18 Z"
        [attr.fill]="'url(#jerseyWhiteGrad-' + uniqueId + ')'"
        stroke="#cbd5e1"
        stroke-width="1.2"
        stroke-linejoin="round"
      />

      @if (variant() === 'away') {
        <!-- Navy raglan sleeves distinguish the away kit while keeping sponsors readable. -->
        <path d="M 62 18 L 28 30 L 6 60 L 20 74 L 38 56 Q 48 38 62 18 Z" fill="#1e3a5f" />
        <path d="M 98 18 L 132 30 L 154 60 L 140 74 L 122 56 Q 112 38 98 18 Z" fill="#1e3a5f" />
      }

      <!-- Subtle athletic raglan shoulder seams -->
      <path
        d="M 62 18 Q 48 38 38 56"
        fill="none"
        stroke="#e2e8f0"
        stroke-width="1.2"
        stroke-dasharray="2,2"
      />
      <path
        d="M 98 18 Q 112 38 122 56"
        fill="none"
        stroke="#e2e8f0"
        stroke-width="1.2"
        stroke-dasharray="2,2"
      />

      <!-- Side ventilation panels with subtle tint -->
      <path
        d="M 38 56 L 34 130 L 40 130 L 43 56 Z"
        fill="#f8fafc"
        opacity="0.8"
      />
      <path
        d="M 122 56 L 126 130 L 120 130 L 117 56 Z"
        fill="#f8fafc"
        opacity="0.8"
      />

      <!-- Inner neck shadow (gives 3D depth inside collar) -->
      <path
        d="M 62 18 Q 80 10 98 18 Q 80 26 62 18 Z"
        fill="#1e293b"
      />
      <!-- Inner neck size label strip -->
      <path
        d="M 72 16 Q 80 13 88 16"
        stroke="#475569"
        stroke-width="1.5"
        fill="none"
      />

      <!-- Collar Trim (White ribbed collar with club accent line) -->
      <path
        d="M 62 18 Q 80 26 98 18"
        fill="none"
        stroke="#ffffff"
        stroke-width="4.5"
        stroke-linecap="round"
      />
      <path
        d="M 63 19 Q 80 26.5 97 19"
        fill="none"
        [attr.stroke]="clubColor()"
        stroke-width="2"
        stroke-linecap="round"
      />

      <!-- Left Sleeve Cuff Accent Trim (Club primary color) -->
      <path
        d="M 6 60 L 20 74"
        [attr.stroke]="clubColor()"
        stroke-width="3"
        stroke-linecap="round"
      />

      <!-- Right Sleeve Cuff Accent Trim (Club primary color) -->
      <path
        d="M 154 60 L 140 74"
        [attr.stroke]="clubColor()"
        stroke-width="3"
        stroke-linecap="round"
      />

      <!-- Kit Supplier Mark on Right Chest -->
      <g opacity="0.6">
        <path
          d="M 104 41 L 112 37 L 112 45 Z"
          fill="#475569"
        />
      </g>

      <!-- Bottom Hem Curved Line -->
      <path
        d="M 34 130 Q 80 135 126 130"
        fill="none"
        stroke="#e2e8f0"
        stroke-width="1"
      />
    </svg>

    <!-- Left Chest: CLUB SHIELD OVERLAY -->
    <div
      class="absolute top-[32%] left-[35%] -translate-x-1/2 -translate-y-1/2 w-[13%] h-[16%] flex items-center justify-center pointer-events-none select-none z-10"
    >
      <app-club-shield
        [shield]="effectiveShield()"
        [club]="club()"
        [clubId]="club()?.id"
        [fallbackText]="clubCode()"
        [fallbackBgColor]="clubColor()"
        size="custom"
        class="w-full h-full flex items-center justify-center"
      />
    </div>

    <!-- Center Chest: THE SPONSOR LOGO -->
    <div
      class="absolute top-[61%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-[68%] h-[52%] flex items-center justify-center pointer-events-none select-none px-0.5"
    >
      @if (logoUrl()) {
        <img
          [src]="logoUrl()!"
          [alt]="sponsorName() || 'Sponsor'"
          class="w-full h-full object-contain drop-shadow-xs filter contrast-105"
          referrerpolicy="no-referrer"
        />
      } @else {
        @switch (brandType()) {
          @case ('adidas') {
            <div class="flex flex-col items-center justify-center leading-none text-slate-900">
              <svg viewBox="0 0 48 22" class="w-8 sm:w-10 h-4 sm:h-5 fill-slate-900" aria-label="Adidas">
                <path d="M6 21 L11 21 L16 13 L11 13 Z"/>
                <path d="M17 21 L22 21 L29 7 L24 7 Z"/>
                <path d="M28 21 L33 21 L42 1 L37 1 Z"/>
              </svg>
              <span class="text-[9px] sm:text-[10px] font-black tracking-tight font-sans lowercase text-slate-900 mt-0.5">adidas</span>
            </div>
          }
          @case ('novasport') {
            <div class="flex flex-col items-center justify-center leading-none text-blue-900">
              <div class="flex items-center space-x-1">
                <svg viewBox="0 0 20 20" class="w-3.5 h-3.5 fill-blue-600 shrink-0" aria-hidden="true">
                  <path d="M10 1 L12.5 7 L19 7.5 L14 12 L15.5 18.5 L10 15 L4.5 18.5 L6 12 L1 7.5 L7.5 7 Z"/>
                </svg>
                <span class="text-[9px] sm:text-[10.5px] font-black italic tracking-tighter text-blue-900 font-sans uppercase">NOVA SPORT</span>
              </div>
            </div>
          }
          @case ('novasport2') {
            <div class="flex flex-col items-center justify-center leading-none text-indigo-950">
              <div class="flex items-center space-x-1">
                <svg viewBox="0 0 20 20" class="w-3.5 h-3.5 fill-indigo-600 shrink-0" aria-hidden="true">
                  <path d="M10 1 L12.5 7 L19 7.5 L14 12 L15.5 18.5 L10 15 L4.5 18.5 L6 12 L1 7.5 L7.5 7 Z"/>
                </svg>
                <span class="text-[8.5px] sm:text-[10px] font-black italic tracking-tighter text-indigo-950 font-sans uppercase">NOVA SPORT 2</span>
              </div>
            </div>
          }
          @case ('pladur') {
            <div class="flex flex-col items-center justify-center leading-none text-center">
              <div class="flex items-center space-x-1">
                <svg viewBox="0 0 16 16" class="w-3.5 h-3.5 text-amber-600 fill-amber-600 shrink-0" aria-hidden="true">
                  <rect x="1" y="1" width="6" height="6" rx="1"/>
                  <rect x="9" y="1" width="6" height="6" rx="1"/>
                  <rect x="1" y="9" width="6" height="6" rx="1"/>
                  <rect x="9" y="9" width="6" height="6" rx="1" class="fill-amber-500"/>
                </svg>
                <span class="text-[8.5px] sm:text-[10px] font-black tracking-tight text-slate-900 font-sans uppercase">PLADUR ÓSCAR</span>
              </div>
              <span class="text-[6.5px] sm:text-[7.5px] font-bold tracking-widest text-slate-500 uppercase mt-0.5">INSTALACIONES</span>
            </div>
          }
          @case ('emirates') {
            <div class="flex flex-col items-center justify-center leading-none text-center">
              <span class="text-[8px] sm:text-[9px] font-medium italic text-red-600 font-serif">Fly</span>
              <span class="text-[10.5px] sm:text-[12px] font-black tracking-wider text-red-700 font-serif uppercase">Emirates</span>
            </div>
          }
          @case ('custom') {
            <div class="flex flex-col items-center justify-center leading-none text-center px-1">
              <span class="text-[8.5px] sm:text-[10px] font-black tracking-tight text-slate-900 font-sans uppercase truncate max-w-[85px]">
                {{ sponsorName() }}
              </span>
              <span class="text-[6px] sm:text-[7px] font-bold text-slate-400 uppercase tracking-widest mt-0.5">SPONSOR</span>
            </div>
          }
          @default {}
        }
      }
    </div>
  </div>

  <!-- Sponsor Label / Contract CTA below jersey -->
  <div class="mt-1 flex flex-col items-center text-center max-w-[160px] sm:max-w-[190px] w-full px-1">
    @if (sponsorName()) {
      <div class="text-[11px] sm:text-[12px] font-bold text-slate-800 dark:text-slate-200 leading-tight w-full break-words" [title]="sponsorName()">
        {{ sponsorName() }}
      </div>
    } @else {
      @if (isUser()) {
        <button
          type="button"
          (click)="onJerseyClick()"
          class="text-[9.5px] sm:text-[10px] text-emerald-600 hover:text-emerald-700 dark:text-emerald-400 font-semibold flex items-center space-x-0.5 hover:underline cursor-pointer"
        >
          <span>+ Contratar sponsor</span>
        </button>
      } @else {
        <span class="text-[9.5px] sm:text-[10px] text-slate-400 dark:text-slate-500">Sin patrocinio</span>
      }
    }
  </div>
</div>
